var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[_c('MenuNav'),_c('v-row',[_vm._l((_vm.$store.getters['CategoriesModule/itemsOfSelected']),function(item){return [(item.restricted !== 'temporary')?_c('v-col',{key:item.nameFull,attrs:{"cols":"12","sm":"6","md":"4","lg":"3","xl":"2"}},[_c('CardItem',{attrs:{"item":item}})],1):_vm._e()]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }